import type {Offer} from '@chekin/core';
import {
  isEarlyCheckInOffer,
  isLateCheckOutOffer,
} from 'utils/upselling/selectRegistrationDeal';
import type {VelaStayOffers} from './types';

type StayOffer = Pick<Offer, 'id' | 'category' | 'template'>;

export function getStayOffers(offers: StayOffer[] = []): VelaStayOffers {
  return {
    earlyCheckInId: offers.find(isEarlyCheckInOffer)?.id ?? null,
    lateCheckOutId: offers.find(isLateCheckOutOffer)?.id ?? null,
  };
}
